import {
  ORDER_PAYMENT_SETTING_API_COD,
  ORDER_PAYMENT_SETTING_API_TRANSFER,
} from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import {
  OrderCodPaymentSettingModel,
  OrderTransferPaymentSettingModel,
} from "./payment-setting.models";

export const getOrderCodPaymentSettingAPI = async () => {
  const createResponse = await apiClient.getHttp<OrderCodPaymentSettingModel>(
    `${ORDER_PAYMENT_SETTING_API_COD}`
  );
  return createResponse;
};

export const updateOrderCodPaymentSettingAPI = async (
  model: OrderCodPaymentSettingModel
) => {
  const createResponse = await apiClient.putHttp(
    `${ORDER_PAYMENT_SETTING_API_COD}`,
    model
  );
  return createResponse;
};

export const getOrderTransferPaymentSettingAPI = async () => {
  const createResponse =
    await apiClient.getHttp<OrderTransferPaymentSettingModel>(
      `${ORDER_PAYMENT_SETTING_API_TRANSFER}`
    );
  return createResponse;
};

export const updateOrderTransferPaymentSettingAPI = async (
  model: OrderTransferPaymentSettingModel
) => {
  const createResponse = await apiClient.putHttp(
    `${ORDER_PAYMENT_SETTING_API_TRANSFER}`,
    model
  );
  return createResponse;
};
